import React from 'react';
import SystemResourcesOverview from '../components/SystemResourcesOverview';

const SystemResources = () => {
  return (
    <div className="space-y-6">
      <SystemResourcesOverview />
    </div>
  );
};

export default SystemResources; 